import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { apiURL } from '../../utilities/URLs'
import { account } from '../../classes/Account'
import { setStoredSessionId } from '../../utilities/tracking/sessionStorage'

import ertcLogo from '../../assets/ertcLogo.png'

export default function AddBankingLogin ({ setShowNavBar, setApplicationId }) {
  const navigate = useNavigate()
  const { applicationId, token } = useParams()
  const [error, setError] = useState('')

  useEffect(() => {
    const handleBankingAccessLogin = async () => {
      try {
        const loginResponse = await fetch(
          `${apiURL}/api/login/banking/${applicationId}/${token}`,
          { credentials: 'include' }
        )
        const loginData = await loginResponse.json()

        if (loginData.response?.error) {
          setError(loginData.response.error)
          return
        }

        account.setAccount(loginData.response.account)
        account.accessToken = loginData.response.accessToken
        localStorage.setItem('portalAccessToken', loginData.response.accessToken)

        if (loginData.response.sessionId)
          setStoredSessionId(loginData.response.sessionId)

        setShowNavBar(true)
        setApplicationId(applicationId)
        navigate(loginData.response.redirect || `/applications/${applicationId}/bank-verification?update=1`)
      } catch {
        setError('Something went wrong while opening your banking setup link. Please try again or sign in to the portal.')
      }
    }

    handleBankingAccessLogin()
  }, [applicationId, token, navigate, setApplicationId, setShowNavBar])

  return (
    <div className='w-screen h-screen flex flex-col items-center justify-center p-6'>
      <div className='w-full flex flex-col items-center max-w-md p-6 bg-gray-200 dark:bg-slate-700 shadow-md rounded-md transition-colors'>
        <img src={ertcLogo} alt='ERTC Logo' className='w-48 mb-6' />
        {!error ? (
          <div className='flex flex-row items-center justify-center gap-2 mt-5'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
            <p className='text-md text-center'>Preparing your secure banking setup...</p>
          </div>
        ) : (
          <div className='flex flex-col items-center gap-4 text-center'>
            <p className='text-red-600 dark:text-red-400'>{error}</p>
            <button
              type='button'
              onClick={() => navigate(`/?bankingLinkError=${encodeURIComponent(error)}&redirect=${encodeURIComponent(`/applications/${applicationId}/bank-verification?update=1`)}`)}
              className='px-6 py-2 bg-ertc-primary text-white rounded-lg hover:bg-ertc-primary-dark transition-all cursor-pointer'
            >
              Go to Portal Sign In
            </button>
          </div>
        )}
      </div>
    </div>
  )
}
